const footer = {
  information: {
    title: 'Informationen',
    toggle: 'kub-footer-information-collapse',
    links: {
      blog: {
        name: 'Blog',
        src: 'https://www.planen-netze-beutel.de/blog/'
      }
    },
    modal: {
      shipping: {
        name: 'Versandkosten',
        header: 'Versandkosten',
        modal: 'kub-shipping',
        comp: 'app-shipping',
        id: 1
      },
      deliveryTime: {
        name: 'Lieferzeit',
        header: 'Lieferzeit',
        modal: 'kub-delivery-time',
        comp: 'app-delivery-time',
        id: 2
      },
      sample: {
        name: 'kostenloses Muster',
        header: 'Kostenloses Muster',
        modal: 'kub-sample',
        comp: 'app-sample',
        id: 3
      }
    }
  },
  legal: {
    title: 'Rechtliches',
    toggle: 'kub-footer-legal-collapse',
    modal: {
      dataProt: {
        name: 'Datenschutz',
        header: 'Datenschutzerklärung',
        modal: 'kub-footer-privacy',
        comp: 'app-privacy',
        id: 1
      },
      termsAndCond: {
        name: 'AGB',
        header: 'Allgemeine Geschäftsbedingungen',
        modal: 'kub-footer-termsAndConditions',
        comp: 'app-terms',
        id: 2
      },
      imprint: {
        name: 'Impressum',
        header: 'Impressum',
        modal: 'kub-footer-imprint',
        comp: 'app-imprint',
        id: 3
      },
      disclaimer: {
        name: 'Widerrufsrecht',
        header: 'Widerrufsrecht',
        modal: 'kub-footer-disclaimer',
        comp: 'app-disclaimer',
        id: 4
      }
    }
  },
  contact: {
    title: 'Kontakt',
    toggle: 'kub-footer-contact-collapse'
  },
  paymentMethods: {
    title: 'Zahlungsarten'
  },
  socialmedia: {
    title: 'Folge uns',
    platform: {
      facebook: {
        img: {
          src: require('../../assets/img/icons/facebook.svg'),
          alt: 'Facebook'
        },
        href: 'https://www.facebook.com/planen.netze.beutel'
      },
      youtube: {
        img: {
          src: require('../../assets/img/icons/youtube.svg'),
          alt: 'YouTube'
        },
        href: 'https://www.youtube.com/@planennetzebeutel'
      },
      pinterest: {
        img: {
          src: require('../../assets/img/icons/pinterest.svg'),
          alt: 'Pinterest'
        },
        href: 'https://de.pinterest.com/planennetzebeutel/'
      }
    }
  },
  copyright: '© 2021 Kubulus'
}

export default {
  footer
}
